import React, { useEffect, useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import Collapse from "../../components/atoms/colapso";
import Footer from "../../components/organisms/footer";
import NavBar from "../../components/organisms/navbar";
import { FaMapMarkerAlt } from 'react-icons/fa';
//import useAuthenticate from "../../hooks/useAuthenticate";
import {
  Container,
  Content,
  H3,
  H5,
  Location,
  P,
  QRCodeImg,
  Span,
  Title,
  TournamentActions,
  TournamentBanner,
  TournamentContainer,
  TournamentContainerBanner,
  TournamentContent,
  TournamentDescription,
  TournamentEnrollmentLink,
  TournamentEnrollmentLinkEndpage,
  TournamentLink,
  EditalContainer,
  EditalContent,
  EditalTitle
} from "./styles";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../../services/api";
import Swal from "sweetalert2";
// import tabelaPeso from "../../assets/images/tournaments/toledo-international-open-brazilian-jiu-jitsu-2023/tabepla-de-peso.jpeg";
import tabelaPeso from "../../assets/images/tournaments/circuito-internacional-de-jiu-jitsu-2026/tabela-circuito-internacional-de-jiu-jitsu-2026.jpg";
import qrCodecopaAmizadeDeJiuJitsu2024 from "../../assets/images/tournaments/copa-amizade-de-jiu-jitsu-2024/qr-coce--copa-amizade-de-jiu-jitsu-2024.jpg";

//Patrocinio
import torneio from "../../assets/images/sponsors/torneio-facil.png";
import prefeituraCascavel from "../../assets/images/sponsors/governo-municipal-cascavel.jpeg";
import camaraCascavel from "../../assets/images/sponsors/camara-municipal-cascavel.jpeg";
import secretariaCascavel from "../../assets/images/sponsors/secretaria-municipal-cascavel.jpeg";
import sinpff from "../../assets/images/sponsors/sinppf-pr-final.png";
import logoCasp from "../../assets/images/sponsors/logo-casplogo.png";



//Apoio
import trevusMartialArts from "../../assets/images/sponsors/trevus-martial-arts.jpg";
import { SponsorContainer, SponsorList } from "src/components/atoms/sponsor-area/styles";
import SponsorButton from "src/components/atoms/sponsor-area";
import useAuthenticate from "../../hooks/useAuthenticate";

const sponsors = [

  { img: prefeituraCascavel, url: "" }, 
  { img: camaraCascavel, url: "" },
  { img: secretariaCascavel, url: "" },  
  { img: sinpff, url: "" },
  { img: logoCasp, url: "" },  
 /*  { img: torneio, url: "http://www.torneiofacil.com" } */
];


const support = [
  
  /* { img: goldstar, url: "" },
  { img: institutoAlfa, url: "" }, 
  { img: contur, url: "" },
  { img: anjosDoCombat, url: "" }, */
 /*  { img: piku, url: "" }, 
  { img: logoRedLions, url: "" }, */
  { img: torneio, url: "http://www.torneiofacil.com" },
];


const cacheBuster = `?cacheBuster=${new Date().getTime()}`
const dataEvento = "22 de março de 2026 "
const horaEvento = "9:00h da manhã"
const tituloEvento = "Circuito Internacional de Jiu Jitsu GI e NOGI - Sinppfpr"
const localEvento = "Centro Esportivo Ciro Nardi"
const endereçoEvento = "R. Barão do Cerro Azul, 484 - Centro, Cascavel - PR, CEP 85801-080"
const dataDeEncerramentoIncricao = "19/MAR/2026"
const horaDeEncerramentoIncricao = "23h:59"

const dataDeEncerramentoCorrecao = "19/MAR/2026"
const horaDeEncerramentoCorrecao = "23h:59min"

const dataDeEncerramentoInscricaoLote1 = "31/JAN/2026"
const dataDeEncerramentoInscricaoLote2 = "10/MAR/2026"
const dataDeEncerramentoInscricaoLote3 = "19/MAR/2026"

//Valores LOTE 1 até 31/01/2026
const valorinscricaoCategoriaLote1 = "99,00 (noventa e nove reais)"
const valorinscricaoLote1ComboGieNogi = "139,00 (cento e trinta e nove reais)"


//Valores LOTE 2 até 10/03/2026
const valorinscricaoCategoriaLote2 = "129,00 (cento e vinte e nove reais)"
const valorinscricaoLote2ComboGieNogi = "169,00 (cento e sessenta e nove reais)"

//Valores LOTE 3 até 19/03/2026
const valorinscricaoCategoriaLote3 = "169,00 (cento e sessenta e nove reais)"
const valorinscricaoLote3ComboGieNogi = "199,00 (cento e noventa e nove reais)"

const dataDeDivulgacaoChaves = "21/MAR/2026"
const horaDeDivulgacaoChaves = "23h:59min"

const instituicaoBancaria = "Bradesco"
const tipoDeChavePix = "Telefone"
const ChavePix = "(92) 99468-5161"
const BeneficiarioDaChavePix = "José Michel Tavares Pio"

const dataDeDivulgacaoCronograma = " "
const horaDeDivulgacaoCCronograma = " "

const contatoWhatsApp1 = "+55 (45) 99854-4432 - Alexandre"
const contatoWhatsApp2 = "+55 (45) 99148-0805"
const contatoWhatsAppTorneio = "+55 (11) 94456-3515"

const slugGI = "circuito-internacional-de-jiu-jitsu-cascavel-pr-gi";
const slugNOGI = "circuito-internacional-de-jiu-jitsu-cascavel-pr-nogi";
const rotaInscriçaoGi = `/enrollment/circuito-internacional-de-jiu-jitsu-cascavel-pr-gi`;
const rotaChecagemGi = "/check/circuito-internacional-de-jiu-jitsu-cascavel-pr-gi/search";
const rotaChecagemNogi = "/check/circuito-internacional-de-jiu-jitsu-cascavel-pr-nogi/search";
const rotaChavesGi = "/tournament/keys/circuito-internacional-de-jiu-jitsu-cascavel-pr-gi"
const rotaChavesNogi = "/tournament/keys/circuito-internacional-de-jiu-jitsu-cascavel-pr-nogi"


const CircuitoInterDeJiuJitsu2026: React.FC = () => {
  const { authenticated, getToken } = useAuthenticate();
  const navigate = useNavigate();

  const handleToSubscriptionPage = async () => {

    if (!authenticated) {
      Swal.fire({
        title: 'Você precisa estar autenticado',
        text: 'Deseja fazer login para se inscrever no evento?',
        icon: 'info',
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: 'Fazer login',
        focusConfirm: false,
        cancelButtonText: 'Agora não'
      }).then((action) => {
        if (action.isConfirmed) navigate('/login')
      });
      return;
    }

    const response = await api.get(
      `/tournaments/info/${slugGI}`,
      {
        headers: { Authorization: `Bearer ${getToken()}` },
      }
    );

    if (response.data.canSubscribe === false) {
      Swal.fire({
        title: 'Atenção!',
        text: 'Período de inscrição encerrado!',
        icon: 'error',
      });
      toast.error('Período de inscrição encerrado!');
      return;
    }

    navigate(`/enrollment/${slugGI}`)

  }
  return (
    <>
      <NavBar />

      <Container>
        <TournamentContainer
          image={require("../../assets/images/tournaments/circuito-internacional-de-jiu-jitsu-2026/circuito-internacional-de-jiu-jitsu-2026-home.jpeg")}
        >
          <TournamentContainerBanner>
            <TournamentBanner
              image={require("../../assets/images/tournaments/circuito-internacional-de-jiu-jitsu-2026/circuito-internacional-de-jiu-jitsu-2026-torneio.jpeg")}
              imageMobile={require("../../assets/images/tournaments/circuito-internacional-de-jiu-jitsu-2026/circuito-internacional-de-jiu-jitsu-2026-home.jpeg")}
            />
          </TournamentContainerBanner>
        </TournamentContainer>
        <TournamentContent>
          <Content>
            <Title>{tituloEvento}</Title>
            <Location>
              <Span>Data: {dataEvento}</Span>
              <Span>Início: {horaEvento}</Span>
              <Span>Local: {localEvento}</Span>
              <Span>Endereço: {endereçoEvento}</Span>
              <Span>
                <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                  <FaMapMarkerAlt style={{ marginRight: '8px', color: "red" }} />
                  <a
                    target={"blank"}
                    style={{ color: "#000", textDecoration: "none", fontWeight: "bold" }}
                    href="https://maps.app.goo.gl/Fa64gmUBQ9h1RBuk6"
                  >
                    Ver no Google Maps
                  </a>
                </div>
              </Span>
            </Location>
            <P></P>
            <br />

          </Content>
        </TournamentContent>
        <TournamentDescription>
          <TournamentActions>
            <Content>
              <h1 style={{ textAlign: "center" }}>PATROCINADORES</h1>
              <SponsorContainer>
                <SponsorList>
                  {sponsors && sponsors.map((buttons: any, index: number) => (
                    <SponsorButton
                      key={index} // Adicionei uma chave única para cada botão
                      img={buttons.img}
                      url={buttons.url}
                      hasError={false}
                      error="Este campo é obrigatório"
                      target="_blank" // Adicione este atributo
                    />
                  ))}
                </SponsorList>
              </SponsorContainer>
              <h1 style={{ textAlign: "center" }}>APOIO</h1>
              <SponsorContainer>
                <SponsorList>
                  {support &&
                    support.map((buttons: any) => (
                      <SponsorButton
                        img={buttons.img}
                        url={buttons.url}
                        hasError={false}
                        error="Este campo é obrigatório"
                      />
                    ))}
                </SponsorList>
              </SponsorContainer>
            </Content>

            <Content style={{
              marginTop: '32px'
            }}>

              <EditalContainer>
                <EditalTitle>EDITAL {tituloEvento.toLocaleUpperCase()}</EditalTitle>
                <EditalContent>
                  <Span>
                      O {tituloEvento} é um evento esportivo de caráter policial, aberto à participação 
                      de toda a sociedade, tanto na condição de atletas quanto de espectadores. O evento 
                      será realizado em território nacional, com início no estado do Paraná, e tem como 
                      objetivo principal fomentar e incentivar a prática da arte marcial jiu-jitsu como 
                      instrumento de defesa pessoal, para toda a sociedade, com enfoque para a comunidade policial.
                      As lutas serão GI (com kimono) e NOGI (sem kimono), o evento disponibilizará
                      categorias para todas as idades e faixas, conforme as tabelas de peso
                      deste edital. Os competidores terão a oportunidade de testar suas
                      habilidades em um ambiente controlado e com acompanhamento de
                      profissionais qualificados.
                  </Span>
                  <br />
                  <br />
                  <br />
                </EditalContent>

                <Collapse title="PROTOCOLO DE SEGURANÇA CONTRA COVID-19">
                  <P>
                    Devido a dinâmica da situação atual, estamos avaliando diariamente as
                    recomendações dos Órgãos de Saúde e este protocolo pode ser atualizado a
                    qualquer momento caso novas determinações sejam publicadas.
                  </P>
                  <P>
                    Caso o evento seja cancelado por força maior, todas as inscrições pagas serão
                    automaticamente reembolsadas.
                  </P>
                  <P>
                    A organização não é responsável pelos demais custos dos participantes,
                    tais como transporte e hospedagem.
                  </P>
                  <P>
                    Diretrizes do ginásio: Para a segurança de todos, por favor verifique
                    sua temperatura antes de se dirigir ao evento.{" "}
                  </P>
                  <P>Caso haja qualquer sintoma, procure um médico.</P>{" "}
                  <P>
                    {" "}
                    Caso você se sinta indisposto ou esteve em contato com um paciente
                    diagnosticado com Covid-19, por favor fique em casa e procure seu
                    médico.
                  </P>
                  {/* <P>
                  Todo nosso material será desinfetado antes e durante o evento.
                </P> */}
                </Collapse>
                <Collapse title="PREMIAÇÕES: DINHEIRO💰 + TROFÉU🏆 + MEDALHAS🥇" >

                  <H3>Academias:</H3>
                  <P>1° lugar: 🏆 Troféu </P>
                  <P>2° lugar: 🏆 Troféu </P>
                  <P>3° lugar: 🏆 Troféu </P>
                  <br />
                  <p>
                  1 troféu para o atleta PPF com melhor desempenho;
                  </p>
                  <p>
                  1 troféu para o Policial que não seja PPF, com melhor desempenho;
                  </p>
                  <br />
                  <H3>Absoluto Masculino GI :</H3> 
                {/*   <P>1° lugar: medalha🥇</P>
                  <P>2° lugar: medalha🥈</P>
                  <P>3° lugar: medalha🥉</P> */}
          {/*         <H5>Juvenil Branca </H5>
                  <P>1° lugar: R$500,00 + Medalha🥇</P>
                  <P>2° lugar: Medalha🥈</P>
                  <P>3° lugar: Medalha🥉</P>
                  <H5>Juvenil Graduado </H5>
                  <P>1° lugar: R$500,00 +  + Medalha🥇</P>
                  <P>2° lugar: Medalha🥈</P>
                  <P>3° lugar: Medalha🥉</P> */}
                  <H5>Adulto e Master Branca </H5>
                  <P>1° lugar: R$500,00  + Medalha🥇</P>
                  <P>2° lugar: R$300,00 + Medalha🥈</P>
                  <P>3° lugar: R$100,00 + Medalha🥉</P>
                  <H5>Adulto e Master Azul </H5>
                  <P>1° lugar: R$400,00  + Medalha🥇</P>
                  <P>2° lugar: R$200,00 + Medalha🥈</P>
                  <P>3° lugar: R$100,00 + Medalha🥉</P>
                  <H5>Adulto e Master Roxa </H5>
                  <P>1° lugar: R$300,00  + Medalha🥇</P>
                  <P>2° lugar: R$200,00 + Medalha🥈</P>
                  <P>3° lugar: R$100,00 + Medalha🥉</P>
                  <H5>Adulto e Master Marrom </H5>
                  <P>1° lugar: R$200,00  + Medalha🥇</P>
                  <P>2° lugar: R$100,00 + Medalha🥈</P>
                  <P>3° lugar: R$100,00 + Medalha🥉</P>
                  <H5>Adulto e Master Preta </H5>
                  <P>1° lugar: R$500,00  + Medalha🥇</P>
                  <P>2° lugar: R$300,00 + Medalha🥈</P>
                  <P>3° lugar: R$150,00 + Medalha🥉</P>
                  <br />

                  <H3>Absoluto Feminino GI:</H3>
                {/*   <P>1° lugar: medalha🥇</P>
                  <P>2° lugar: medalha🥈</P>
                  <P>3° lugar: medalha🥉</P> */}
                  <H5>Adulto e Master Branca </H5>
                  <P>1° lugar: R$500,00  + Medalha🥇</P>
                  <P>2° lugar: R$300,00 + Medalha🥈</P>
                  <P>3° lugar: R$100,00 + Medalha🥉</P>
                  <H5>Adulto e Master Azul </H5>
                  <P>1° lugar: R$400,00  + Medalha🥇</P>
                  <P>2° lugar: R$200,00 + Medalha🥈</P>
                  <P>3° lugar: R$100,00 + Medalha🥉</P>
                  <H5>Adulto e Master Roxa </H5>
                  <P>1° lugar: R$300,00  + Medalha🥇</P>
                  <P>2° lugar: R$200,00 + Medalha🥈</P>
                  <P>3° lugar: R$100,00 + Medalha🥉</P>
                  <H5>Adulto e Master Marrom </H5>
                  <P>1° lugar: R$200,00  + Medalha🥇</P>
                  <P>2° lugar: R$100,00 + Medalha🥈</P>
                  <P>3° lugar: R$100,00 + Medalha🥉</P>
                  <H5>Adulto e Master Preta </H5>
                  <P>1° lugar: R$500,00  + Medalha🥇</P>
                  <P>2° lugar: R$300,00 + Medalha🥈</P>
                  <P>3° lugar: R$150,00 + Medalha🥉</P>

               {/*    <br /> 
                  <H3>Absoluto Masculino NOGI :</H3> 
                  <H5>Adulto e Master Branca </H5>
                  <P>1° lugar: R$300 + Medalha🥇</P>
                  <P>2° lugar: + Medalha🥈</P>
                  <P>3° lugar: + Medalha🥉</P>
                  <H5>Adulto e Master Azul e Roxa - (Juntos) </H5>
                  <P>1° lugar:R$700,00 + Medalha🥇</P>
                  <P>2° lugar: + Medalha🥈</P>
                  <P>3° lugar: + Medalha🥉</P>
                  <H5>Adulto e Master  Marrom e Preta - (Juntos) </H5>
                  <P>1° lugar:R$1.000,00 + Medalha🥇</P>
                  <P>2° lugar: + Medalha🥈</P>
                  <P>3° lugar: + Medalha🥉</P>
                  <br /> 
                  <H3>Absoluto Feminino NOGI :</H3> 
                  <H5>Adulto e Master Branca </H5>
                  <P>1° lugar: R$300 + Medalha🥇</P>
                  <P>2° lugar: + Medalha🥈</P>
                  <P>3° lugar: + Medalha🥉</P>
                  <H5>Adulto e Master Azul e Roxa - (Juntas) </H5>
                  <P>1° lugar:R$700,00 + Medalha🥇</P>
                  <P>2° lugar: + Medalha🥈</P>
                  <P>3° lugar: + Medalha🥉</P>
                  <H5>Adulto e Master  Marrom e Preta - (Juntas) </H5>
                  <P>1° lugar:R$1.000,00 + Medalha🥇</P>
                  <P>2° lugar: + Medalha🥈</P>
                  <P>3° lugar: + Medalha🥉</P>
                  <br />  */}
                  <br />
                  <H3>Demais Categorias GI</H3>
                  <P>1° lugar: medalha🥇</P>
                  <P>2° lugar: medalha🥈</P>
                  <P>3° lugar: medalha🥉</P>

                  
                  <br />
                  <P>Não terá absoluto NOGI</P>
                  <p>
                  Serão concedidos troféus personalizados às academias que conquistarem o 1º, 2º e 3º lugares, 
                  conforme pontuação geral obtida por seus atletas ao longo da competição, considerando todas as categorias disputadas. 
                  Também, será concedido benefícios de reconhecimento oficial com divulgação nas redes sociais de alguns patrocinadores e canais do evento. 
                  </p>
                  <p>
                  As premiações em dinheiro somente serão válidas para as categorias absoluto que contarem com 08 (oito) ou mais atletas inscritos, 
                  desde que todas as lutas sejam efetivamente realizadas.
                  </p>
                  <p>
                  Caso haja 08 (oito) atletas inscritos e algum deles não realize suas lutas, a premiação será reduzida para 50% do valor previsto.
                  </p>
                  <p>
                  Nas categorias absoluto com menos de 08 (oito) atletas inscritos, a premiação será exclusivamente medalha.
                  </p>
                  <p>
                  Para a realização da categoria absoluto, será exigido o mínimo de 06 (seis) atletas inscritos.
                  </p>
                  <p>
                  Haverá Absoluto GI apenas para Adulto e Master;
                  </p>
                 
                  
   {/*                <p>
                    OBS: PREMIAÇÕES do Absolutos  e Free Pass = passagens ida e volta + inscrição  do Brasileiro CBJJ 2026
                    (Passagens saindo dos Estados da região Sul do Brasil ou capitais ,Assunção,Buenos Aires ou Santiago).
                  </p>
                   <p>A premiação integral só irá valer para os Absolutos ADULTOS que tiverem no mínimo 8 (OITO)
                    atletas inscritos.</p>
                  <p>
                  Número menor que 7 (SETE) até 5 (CINCO) atletas inscritos a premiação será o valor de R$500,00.
                  </p>
                  <p>
                  Obrigatório ter no mínimo 5 atletas para ter o Absoluto
                  </p>
                  <p>As premiações só irão valer para os Absolutos MASTERS que tiverem no mínimo 5 (CINCO)
                  atletas inscritos.</p>
                   */}
                  <p>
                    Mais informações sobre as inscrições para o absoluto está disponível
                    na seção INSCRIÇÕES, parágrafo Inscrição de Absoluto deste edital.
                  </p>
                  <br />
                </Collapse>

                <Collapse title="INSCRIÇÕES">
                  <Span>
                    As inscrições para o evento serão realizadas exclusivamente online, por
                    meio do site www.torneiofacil.com.br
                  </Span>
                  <P>
                    Durante o processo de inscrição, o atleta ou seu responsável legal
                    deverá selecionar corretamente a categoria referente idade que o atleta
                    completará no ano de 2026, bem como sua faixa e peso.
                  </P>
                  <P>
                    A idade de competição do atleta é a idade máxima que ele terá em 2026,
                    conforme regra da CBJJ.
                  </P>
                  <P>
                    As 100 primeiras inscrições pagas , sem isenções e/ou descontos , terão opção de uma camiseta do evento grátis!
                  </P>
                  <p><strong>Faixas Pretas:</strong></p>
                  <ul>
                    <li>
                    Policiais Penais Federais (PPFs) sindicalizados serão isentos da inscrição.
                    </li>
                    <li>
                    Policiais Penais Federais (PPFs) não sindicalizados, terão 50% desconto na inscrição.
                    </li>
                    {/* <li>
                    Policiais de Cascavel, que não sejam PPFs, terão 25% desconto na inscrição, de acordo com o valor e período dos lotes.
                    </li>
                    <li>
                    Policiais que não sejam de Cascavel, ganham 35% de desconto nas inscrições, de acordo com o valor e período dos lotes.
                    </li> */}
                  </ul>
                  <p><strong>Faixas Coloridas:</strong></p>
                  <ul>
                    <li>
                    Policias PPFs não sindicalizados terão 50% desconto, de acordo com o valor e período dos lotes.
                    </li>
                    <li>
                    Policiais PPFs sindicalizados terão 70% desconto, de acordo com o valor e período dos lotes.
                    </li>
                    <li>
                    {/* Policiais de Cascavel, que não sejam PPFs, terão 20% desconto na inscrição, de acordo com o valor e período dos lotes.
                    </li>
                    <li>
                    Policiais que não sejam de Cascavel, ganham 30% de desconto nas inscrições, de acordo com o valor e período dos lotes. */}
                    </li>
                   {/*  <li>
                    Atletas do Poder judiciário, MPs e Defensoria pública e advocacia privada terão desconto de 20% nas inscrições;
                    </li> */}
                  </ul>
                  <Span>
                  {/* Caso a academia possua policiais entre seus inscritos, estes poderão optar pelo desconto específico para policiais, e 
                  suas inscrições também serão contabilizadas para que a academia atinja o número necessário para obter o desconto por quantidade. */}
                 {/*  (as inscrições com desconto não serão cumulativas, cada atleta deverá optar por apenas uma modalidade de desconto) */}
                  </Span>
           {/*        <Span>
                  Atletas servidores públicos do sistema de justiça criminal (Poder judiciário, MPs, Defensoria pública e advocacia privada) terão desconto de 20% nas inscrições;
                  </Span> */}
                  {/* <Span>
                  Academia de Cascavel, com 15 ou mais atletas inscritos ganham 20% de desconto nas inscrições, independente de categoria;
                  </Span>
                  <Span>
                  Academias fora da cidade de Cascavel com 15 ou mais atletas inscritos ganham 30% de desconto nas inscrições, independente de categoria;
                  </Span>
                  <Span>
                  Atletas servidores públicos do Poder Judiciário, MPs, Defensoria pública e advocacia privada, terão 20% de desconto nas inscrições.
                  </Span> */}
               {/*    <Span>
                  PROCEDIMENTO PARA SOLICITAR DESCONTO POR EQUIPE: Após todos os atletas da academia realizarem suas inscrições, pelo 
                  site torneio Fácil, o responsável pela equipe deverá encaminhar, via Whatsapp para o numero 45 998544432, o número das inscrições
                 e o nome de todos os atletas. A efetivação das inscrições só acontecerá após a confirmação de pagamento de todas as inscrições da equipe.
                  </Span> */}
                 {/*  <Span>
                  Caso a academia possua policiais entre seus inscritos, estes poderão optar pelo desconto específico para policiais, e suas inscrições 
                  também serão contabilizadas para que a academia atinja o número necessário para obter o desconto por quantidade. 
                  </Span>
                  <Span>
                  Atletas do sistema de justiça criminal (Poder judiciário, MPs, Defensoria pública e advocacia privada) terão desconto de 20% nas inscrições;
                  </Span> */}
                  {/* <Span>
                  OBS: As inscrições com desconto não serão cumulativas, cada atleta deverá optar por apenas uma modalidade de desconto.
                  </Span>
                   <p><strong>PROCEDIMENTO PARA SOLICITAÇÃO DE DESCONTO POR EQUIPE:</strong></p> */}
                  {/* <ul>
                    <li>
                    1.DESCONTO POR EQUIPES (ACADEMIAS)
                    Após todos os atletas realizarem suas inscrições pelo site Torneio Fácil, o 
                    responsável pela equipe deverá encaminhar, via WhatsApp, para o número (45) 99854-4432, as seguintes informações:
                    
                    </li>
                    <li>
                      Número das inscrições
                    </li>
                    <li>
                    Nome completo de todos os atletas inscritos
                    </li>
                    <li>
                    A inscrição da equipe será considerada efetivada somente após a confirmação do pagamento integral de todas as inscrições.
                    </li>
                  </ul>  */}
                  {/* <p><strong>PROCEDIMENTO PARA SOLICITAÇÃO DE DESCONTO POR EQUIPE:</strong></p> */}
                  {/* <ul>
                    <li>
                    2.DESCONTO INDIVIDUAL (Atletas servidores públicos do Poder Judiciário, MPs, Defensoria pública e advocacia privada)
                    Os atletas policiais, servidores públicos do Poder Judiciário e advogados deverão realizar a inscrição pelo site Torneio Fácil e, posteriormente, encaminhar, via WhatsApp, para o número (45) 99854-4432, o número da inscrição e o nome completo.
                    </li>
                    <li>
                      Número das inscrições
                    </li>
                    <li>
                    Nome completo de todos os atletas inscritos
                    </li>
                    <li>
                    A inscrição só será considerada efetivada somente após a confirmação do pagamento.
                    </li>
                  </ul>  */}
                  <span>
                    Condições especiais para Policiais, servidores públicos do Poder Judiciário, MPs, Defensoria Pública. 
                    Entrar em contato com Alexandre no numero 45- 9 9854 – 4432 
                  </span>
                  <br />
                  <H3>Prazo de Inscrição</H3>
                  <P>
                    O prazo final para inscrições e pagamento será até  {dataDeEncerramentoIncricao}, às {""}
                    {horaDeEncerramentoIncricao}min.
                  </P>
                  <br />
                  <P>As inscrições que não forem pagas serão canceladas.</P>
                  <br />
                  {/* <H3>Valor  </H3>
                  <P>Primeiro Lote até {dataDeEncerramentoInscricaoLote1}</P>
                  <P>Inscrição categoria R$ {valorinscricaoCategoriaLote1} (quarenta reais)</P>
                  <P>Inscrição absoluto R$ {valorinscricaoCategoriaAbsoluto} (trinta reais)</P>
                  <br />
                  <P>Segundo Lote até {dataDeEncerramentoInscricaoLote2}</P>
                  <P>Inscrição categoria R$ {valorinscricaoCategoriaLote2} (cinquenta reais)</P>
                  <P>Inscrição absoluto R$ {valorinscricaoCategoriaAbsoluto} (trinta reais)</P>
                  <P>Inscrição Combo categoria + absoluto R$ {valorinscricaoLote2ComboGieAbsoluto} (setenta reais)</P>

                  <br />
                  <P>Terceiro Lote até {dataDeEncerramentoInscricaoLote3}</P>
                  <P>Inscrição categoria R$ {valorinscricaoCategoriaLote3} (cinquenta reais)</P>
                  <P>Inscrição absoluto R$ { valorinscricaoCategoriaAbsolutoLote3} (quarenta reais)</P>
                  <P>Inscrição Combo categoria + absoluto R$ {valorinscricaoLote3ComboGieAbsoluto} (cem reais)</P>
                  <br /> */}

                  <H3>Correção</H3>
                  <P>
                    A correção da inscrição poderá ser realizada somente após a confirmação
                    do pagamento.
                  </P>
                  <P>
                    Em caso de inscrição equivocada, o atleta ou professor poderá concordar com as
                    as informações no site www.torneiofacil.com.br,
                    acessando a opção Meu Perfil em seguida Minhas Inscrições.
                  </P>
                  <P>
                    A correção da inscrição ficará disponível até a suspensão das
                    inscrições {dataDeEncerramentoCorrecao} às {horaDeEncerramentoCorrecao}.
                  </P>
                  <P>
                    Após prazo para as correção das inscrições, não serão aceitas modificações
                    nas inscrições.
                  </P>
                  <P>
                    Os atletas que se inscreverem incorretamente estarão sujeitos a
                    desclassificação <b>sem direito a reembolso.</b>
                  </P>
                  <br />
                  <H3>Prazo de Correção</H3>
                  <P>
                    A correção da inscrição fica disponível após a confirmação do pagamento
                    da mesma.
                  </P>
                  <P>
                    A correção da inscrição ficará disponível até a suspensão das
                    inscrições {dataDeEncerramentoCorrecao} as {horaDeEncerramentoCorrecao}.
                  </P>
                  <br />
                  <H3>Checagem</H3>
                  <P>
                    O sorteio e divulgação das chaves de lutas será em {dataDeDivulgacaoChaves} até às {horaDeDivulgacaoChaves}.
                  </P>
                  <br />
                  <H3>Inscrição do Absoluto</H3>
                  <P>
                    Somente atletas inscritos na categoria poderão se inscrever e participar
                    do absoluto.
                  </P>
                  <P>
                    Os atletas só poderão inscrever-se no absoluto referente a categoria da
                    sua inscrição no torneio.  Exceção apenas para os Master que poderá se
                    inscrever como absoluto adulto.
                  </P>
                </Collapse>
                <Collapse title="ENTREGA DAS CAMISETAS">
                  <Span>
                  As camisetas serão entregues exclusivamente no dia da pesagem (sábado ou domingo), conforme a data escolhida pelo atleta.
                  </Span>
                  <Span>
                  A retirada é de inteira responsabilidade do atleta no momento da pesagem. Não haverá entrega em outra data, horário ou local.
                  </Span>
                  <Span>
                  O atleta que não retirar a camiseta perderá o direito ao item, sem devolução de valores.
                  </Span>

                  <br />
                </Collapse>
                <Collapse title="PESSOAS COM DEFICIÊNCIA (PCD)">
                  <H3>
                    As pessoas com deficiência (PCD) devem informar, no momento da
                    inscrição, sua condição pelo WhatsApp. Caso contrário o atleta será
                    desclassificado sem direito a reembolso.
                  </H3>

                  <br />
                </Collapse>

                <Collapse title="VALOR DA INSCRIÇÃO">
                  <Span>
                    As inscrições serão em divididas em três lotes:
                  </Span>
                  <H3>Primeiro Lote valor válido para as 200 primeiras inscrições pagas, ou até {dataDeEncerramentoInscricaoLote1}  </H3>
                  <P>Inscrição categoria Gi ou Nogi R$ {valorinscricaoCategoriaLote1} </P>
                  <P>Inscrição Combo categoria GI + NOGI R$ {valorinscricaoLote1ComboGieNogi} </P>
                  <br />
                  <H3>Segundo Lote até {dataDeEncerramentoInscricaoLote2}</H3>
                  <P>Inscrição categoria Gi ou Nogi R$ {valorinscricaoCategoriaLote2} </P>
                  <P>Inscrição Combo categoria GI + NOGI R$ {valorinscricaoLote2ComboGieNogi} </P>
                  <br />
                  <H3>Terceiro Lote até {dataDeEncerramentoInscricaoLote3}</H3>
                  <P>Inscrição categoria Gi ou Nogi R$ {valorinscricaoCategoriaLote3} </P>
                  <P>Inscrição Combo categoria GI + NOGI R$ {valorinscricaoLote3ComboGieNogi} </P>
                  <br />
                  <H3>
                    Obs:Para as 100 (cem) primeiras inscrições pagas, sem isenções ou descontos , o atleta terá a opção de adquirir a camisa grátis , após isso o valor da camisa será de R$50,00 (cinquenta reais)
                  </H3>
                  <H3>
                    Obs: A venda para as camisas do evento ficará disponível somente até 22/FEV/2026.
                  </H3>

                </Collapse>
                  
                <Collapse title="PAGAMENTO">
                  <H3>
                    A baixa do pagamento será efetuada de forma automática.
                  </H3>
                  <H3>
                    É necessário completar todas as etapas até finalizar a operação de pagamento.
                  </H3>
                  {/* <QRCodeImg src={qrCodecopaAmizadeDeJiuJitsu2024} alt="qrCode" width={300} />
                  <P>
                    <a
                      target={"blank"}
                      style={{ color: "white" }}
                      href="https://whatsa.me/5592981291027/?t=Ol%C3%A1+Thiago_Dellarmelina%2C+vou+enviar+o+comprovante+de+pagamento+referente+a+inscri%C3%A7%C3%A3o+na+%2ACOPA+ORLEY+LOBATO+DE+JIU+JITSU+2024%2A"
                    >
                      <strong>WhatsApp: +55 (92) 98129-1027 </strong>
                      <FaWhatsapp />
                    </a>
                  </P> */}
                  <p />
                  {/* <QRCodeImg src={qrCodeCopaParana} alt="qrCode" width={300} /> */}
                </Collapse>

                <Collapse title="REEMBOLSO DAS INSCRIÇÕES">
                     <H3>
                     Uma vez PAGA a inscrição, o atleta tem direito ao reembolso nas seguintes situações:
                     </H3>
                     <P>
                     1) Quando o evento é CANCELADO.
                     </P>
                     <P>
                     2) Quando ocorre alteração na DATA do evento.
                     </P>
                     <P>
                     3) Quando altera o LOCAL do evento com distância maior que 20km em relação ao anterior.
                     </P>
                     <P>
                     4) Quando há diminuição da premiação, somente para os atletas impactados.
                     </P>
                     <H3>
                     Obs: Para os 4 casos acima, o prazo máximo para solicitar reembolso será de até 5 dias (corridos)
                      após a divulgação do COMUNICADO no site www.torneiofacil.com.br ou DATA FIM da CHECAGEM GERAL ABERTA ( a data que ocorrer primeiro ).
                     </H3>
                     <P>
                     5) Quando o atleta se lesiona e tenha comprado a GARANTIA CAMPEÃ no ato da inscrição (desde que apresente um laudo médico 
                     comprovando a lesão até SEGUNDA-FEIRA antecedente ao evento, através do Fale Conosco). Neste caso da garantia, o atleta 
                     usufrui do reembolso de 80% do valor pago na inscrição.
                     </P>
                     <P>
                     Em caso de CALAMIDADE PÚBLICA, PANDEMIA, CATÁSTROFE NATURAL e DECRETOS GOVERNAMENTAIS, considerados motivo de FORÇA MAIOR,
                      o atleta NÃO TEM direito ao reembolso. 
                     </P>
                     <P>
                     Para estes casos, a organização oferecerá alternativas para uso do crédito do atleta que não puder comparecer na nova data 
                     do evento, ao invés do reembolso, desde que o atleta nos notifique pelo FALE CONOSCO até SEGUNDA-FEIRA antecedente ao evento).
                     </P>
                     <P>
                     Após os períodos predeterminados, o atleta perderá o direito a reembolso ou crédito.
                     </P>
                     <H3>
                     Além disso, o atleta NÃO tem direito a reembolso de valores quando:
                     </H3>
                     <P>
                     1) Está sozinho na chave de luta.
                     </P>
                     <P>
                     2) Se machuca antes do evento impossibilitando o atleta de participar do mesmo, sem ter adquirido a GARANTIA CAMPEÃ.
                     </P>
                     <P>
                     3) Desistência por qualquer motivo.
                     </P>
                    {/* <H3>
                      Em caso de Lesão ou doença , o atleta poderá solicitar o reembolso da
                      inscrição, sendo obrigatório a comprovação e apresentação de atestado
                      médico.
                    </H3>
                    <H3>
                      Após o fim do período de inscrição não será possível o reembolso das
                      inscrições pagas.
                    </H3> */}
                  </Collapse>

                <Collapse title="REGRAS">

                  <Span>
                    Todas as regras para o evento estão devidamente estipuladas e detalhadas neste edital.
                  </Span>
                  <Span>
                    Em casos de omissão de regras no presente edital, as normas a serem observadas serão aquelas estabelecidas pela Confederação
                    Brasileira de Jiu-Jitsu (CBJJ), em conformidade com as diretrizes da CBJJ/IBJJF.
                  </Span>
                  <Span>
                    A tabela de peso por categoria, que estabelece os limites de peso para cada categoria, encontra-se disponível no site oficial do evento,
                    acessível por meio do botão denominado "Tabela de Peso".
                  </Span>
                  <Span>
                    As lutas serão com GI (com kimonos de cores Oficiais pela cbjj branco,
                    azul e preto ) os kimonos devem estar limpos sem rasgos e sem odor .
                  </Span>
                  <Span>
                    Para categoria com 3 lutadores, o lutador que ficar sozinho no sorteio da chave estará automaticamente na final.
                    Em caso de WO de um atleta, os dois lutadores restantes na categoria disputarão a final.
                  </Span>
                  <Span>
                  A pesagem será realizada um dia anterior a data do evento , no Ginásio Ciro Nardi , das 18:00h até 19:30h, bem como, 
                  na data do evento antes de cada luta, o atleta que pesar no dia anterior não precisará pesar na data do evento. O competidor deverá apresentar documento oficial com foto no momento da pesagem.
                  </Span>
{/*                   <Span>
                    A pesagem dos atletas serão realizadas antes do inicio da categoria.
                  </Span> */}
                  <Span>
                    Atletas que ultrapasarem o limite de peso da categoria que estiverem
                    inscritos serão automaticamente desclassificados e não poderão lutar o
                    Absoluto.
                  </Span>
                 <Span>
                 Critério de desempate, para os atletas policias que receberão troféu , será primeiramente por quantidade de medalhas de ouro,
                  depois de prata e depois de bronze, caso haja empate será decidido pela idade, e persistindo o empate será decidido pela cor da faixa, começando pela preta e decrescendo até a branca 1 grau.
                 </Span>
                 <Span>
                 O profissional de segurança pública ou do Sistema de justiça Criminal que desejar receber o desconto, deverá enviar funcional ou documento similar que comprove sua condição de servidor ou OAB, 
                 para o coordenador do evento (Alexandre) que ficará responsável pela inscrição do atleta e pelo sigilo da informação (45998544432).
                 </Span>
                  <Span>
                  Descontos não serão cumulativos. Cada atleta terá direito apenas um desconto.
                  </Span>
                  <Span>
                    Afim de evitar chaves sem lutas o esquema de faixa usado
                    será o seguinte:
                  </Span>
                  <P> Branca; </P>
                  <P> Cinza e Amarela (juntas)</P>
                  <P> Laranja e Verde(juntas)</P>    
                  <P> Azul; </P>
                  <P> Roxa; </P>
                  <P> Marrom; </P>
                  <P> Preta. </P>
                  <Span> Será permitida a inscrição de atletas Juvenil na faixa Verde, porém
                    ele lutará como Juvenil faixa Azul.
                  </Span>
                  <Span>Será realizada apenas uma pesagem oficial por atleta.</Span>
                  <Span>
                  Haverá a possibilidade de termos uma balança para pesagem livre (não oficial) para os atletas.
                  </Span>
             {/*      <Span>
                    Teremos uma balança para pesagem livre (não oficial) para os atletas.
                  </Span> */}
                  {/* <Span>Teremos duas balanças para pesagem oficial dos atletas.</Span> */}
                  {/* <Span>Teremos 4 (quatro) aréas de lutas</Span> */}
                  {/*  <Span>A Arbitragem será composta pela Equipe da Federação de Arbítrio do Amazonas</Span> */}
                  <Span>
                    Atletas que lutaram em outros eventos com faixa superior não poderão
                    lutar com a faixa abaixo. Se descoberto, o competidor será eliminado do
                    torneio sem direito a reembolso.
                  </Span>
                  <br />
                  <H3>Pontuação por equipe</H3>
                  <H5>Categoria e Absoluto, todas as faixas</H5>
                  <P>1° lugar: 9 pontos</P>
                  <P>2° lugar: 3 pontos</P>
                  <P>3° lugar: 1 ponto</P>
                  <P>
                    A contagem dos pontos será realizada de forma geral contabilizando os
                    pontos de todas as faixas.
                  </P>
                  <P>Campeão direto não contam pontos, chaves com apenas um inscrito.</P>
                  <P>
                    Campeão por WO, devido a desistencia do oponente, contará pontos desde
                    que na chave tenha mais de um inscrito.
                  </P>
                  <P>
                    Categorias com atletas somente da mesma academia não contam pontos
                    para a disputa por academias, para contar pontos é necessário ao menos um
                    atleta de outra academia para validar a chave.
                  </P>

                  <br />
                  <H3>Para o absoluto:</H3>
                  <P>
                  Teremos absoluto apenas na modalidade Gi.
                  </P>
                  <P>
                    Não será permitido luta combinada.
                  </P>
                  <P>
                    Não será permitido fechamento dos finalistas.
                  </P>
                  <P>
                    Não será permitido o atleta deixar de fazer o combate, afim de beneficiar o outro atleta.
                  </P>
                  <P>
                    Caso aconteça alguns desses itens acima ,  a organização fica sem a obrigação de fazer a entrega  da premiação  citado nesse edital.
                  </P>
                  <br />
                  <P>
                    O que não estiver neste edital, será acatado o que estiver no livro de
                    regras da CBJJ.
                  </P>
                  <br />
                  <P>
                    <a
                      target={"blank"}
                      href="https://cbjj.com.br/books-videos"
                      style={{ color: "white" }}
                    >
                      <strong>LIVRO DE REGRAS DA CBJJ/IBJJF</strong>
                    </a>
                  </P>
                </Collapse>
                <Collapse title={"CRONOGRAMA" + dataDeDivulgacaoCronograma + " " + horaDeDivulgacaoCCronograma}>
                  (EM BREVE)

                  <Container>
                    <br />
                    {/* <span>
                      CRONOGRAMA III COPA BJJ CASCAVEL DE JIU JITSU 2025

                    </span>
                    <h5>09:15 - Categorias Pré-Mirim e Mirim A - Todas as faixas Masculino/Feminino (área de aquecimento)</h5>
                    <h5>09:30 - Abertura e início do evento</h5>
                    <h5>09:45 - Mirim B - Todas as faixas Masculino/Feminino</h5>
                    <h5>10:15 - Infantil A - Todas as faixas Masculino/Feminino</h5>
                    <h5>10:45 - Infantil B - Todas as faixas Masculino/Feminino</h5>
                    <h5>11:15 - Infanto-Juvenil - Todas as faixas Masculino/Feminino</h5>
                    <h5>11:45 - Juvenil - Todas as faixas Masculino/Feminino</h5>
                    <h5>12:00 - Faixas Marrom e Preta Adulto e Master Masculino/Feminino</h5>
                    <h5>12:30 - Faixa Branca Adulto Masculino/Feminino</h5>
                    <h3>Início NOGI</h3>
                    <h5>13:15 - Faixa Branca Master Masculino/Feminino</h5>
                    <h5>13:45 - Faixa Azul Adulto e Master Masculino/Feminino</h5>
                    <h5>14:00 - Absolutos Juvenil</h5>
                    <h5>14:15 - Faixa Roxa Adulto e Master Masculino/Feminino</h5>
                    <h5>15:00 - Início dos Absolutos Adulto/Master</h5>

                    <p><strong>Informações importantes:</strong></p>
                    <ul>
                      <li>As inscrições do Absoluto deverão ser feitas após o término das categorias.</li>
                      <li>Os absolutos serão disputados após o término das suas respectivas categorias.</li>
                      <li>O cronograma pode ser adiantado em até 1 hora, e atrasar conforme a necessidade do evento.</li>
                      <li>O atleta deverá estar presente no ginásio pelo menos 1 hora antes da sua luta.</li>
                      <li>O atleta que não estiver presente no momento da chamada para a pesagem ou luta será desclassificado por W.O.</li>
                      <li>A pesagem será feita antes da 1ª luta do atleta. Em caso de não bater o peso, o atleta será imediatamente desclassificado.</li>
                      <li>Será verificado também as condições do kimono do atleta antes da luta, podendo ocorrer desclassificação.</li>
                      <li>Todos os atletas devem estar 45 minutos antes do tempo de sua categoria na área de aquecimento, podendo lutar até 30 minutos antes do horário previsto no cronograma.</li>
                      <li>Para o que não estiver presente neste edital, seguiremos normas e regras da CBJJ.</li>
                    </ul>
                    <p><strong>Obs.:</strong> Desejamos a todos um excelente campeonato!</p>
                    <br />Ossssssssss */}
                  </Container>
                </Collapse>
                <Collapse title="ENTRADA">
                   <P>
                   Será cobrado 1kg de alimento não perecível ou ração por pessoa ou R$5.00 reais, exceto para atletas inscritos;
                   </P> 
                   <P>
                   Todo atleta inscrito, para adentrar no ginásio, deverá mostrar sua inscrição via celular ou impresso junto com sua identidade.
                   </P>
                   <P>
                   O evento contará com segurança privada e equipes da Polícia Militar, Polícia Penal (monitorar tornozelados),
                   Polícia Penal Federal e Guarda Municipal dentro e fora do evento.
                   </P>
                    {/* <br />
                <P>Crianças até 5 anos ficam isentas de qualquer tipo de pagamento.</P>
                <br /> */}
                  </Collapse>
                <Collapse title="CONTATO">
                  <P>Caso Precise falar com o responsável do evento, entre em contato por telefone ou WhatsApp.</P>
                  <a target={"blank"} href="https://whatsa.me/5545998544432/?t=Ol%C3%A1,%20Alexandre!%0A%0APreciso%20de%20ajuda%20com%20minha%20inscri%C3%A7%C3%A3o%20no%20*CIRCUITO%20INTERNACIONAL%20DE%20JIU%20JITSU%202026*"
                   >
                    <strong>Telefone/WhatsApp: {contatoWhatsApp1} </strong>
                    <FaWhatsapp />
                  </a>
                  <br />
                  <a target={"blank"} href="https://whatsa.me/5545991480805/?t=Ol%C3%A1,%20Alexandre!%0A%0APreciso%20de%20ajuda%20com%20minha%20inscri%C3%A7%C3%A3o%20no%20*CIRCUITO%20INTERNACIONAL%20DE%20JIU%20JITSU%202026*"
                   >
                    <strong>Telefone/WhatsApp: {contatoWhatsApp2} </strong>
                    <FaWhatsapp />
                  </a>
                  <br />
                  <br />
                  <P>
                    Dúvidas sobre cadastro, inscrição, pagamento, correção, checagem ou
                    sugestão de melhorias entre em contato com a equipe do Torneio Fácil
                    por telefone ou WhatsApp.
                  </P>
                  <P>Melhor horário para atendimento das 18:00h as 23:59h.</P>
                  <a
                    target={"blank"}
                    href="https://whatsa.me/5511944563515/?t=Olá%20Equipe%20Torneio%20Fácil!%0A%0APreciso%20de%20ajuda%20com%20minha%20inscri%C3%A7%C3%A3o%20no%20*CIRCUITO%20INTERNACIONAL%20DE%20JIU%20JITSU%202026*"
                  >
                    <strong>Telefone/WhatsApp: {contatoWhatsAppTorneio} </strong>
                    <FaWhatsapp />
                  </a>

                  <br />
                </Collapse>
              </EditalContainer>
            </Content>
            <br />
            <Content>
              <TournamentEnrollmentLinkEndpage to={""} onClick={() => handleToSubscriptionPage()}>
               {/* <TournamentEnrollmentLinkEndpage to="#"> */}
                Inscrição
              </TournamentEnrollmentLinkEndpage>

              <TournamentEnrollmentLinkEndpage to="/profile/subscription">
                Correção da Inscrição
              </TournamentEnrollmentLinkEndpage>
              {/* <TournamentLink href="http://www.campeonatofacil.com/eventos/jj/main/mainall.asp?s=3.767B171E&u=teste" target="_blank">Chaves</TournamentLink> */}
              {/* // /check/16-COPA-PARANA-DE-JIU-JITSU */}

              <TournamentLink
                // target="_blank"
                href={rotaChecagemGi}
              >
                Checagem GI
              </TournamentLink>
              <TournamentLink
                // target="_blank"
                href={rotaChecagemNogi}
              >
                Checagem NOGI
              </TournamentLink>

              {/* <TournamentLink
                // target="_blank"
                href={rotaChecagemNoGi}
              >
                Checagem NOGI
              </TournamentLink> */}

              {/* 
              <TournamentLink
                href="/check/toledo-international-open-brazilian-jiu-jitsu-nogi-2023-ginasio-de-esportes-alcides-pan-toledo-pr/search"
                target="_blank"
              >
                Checagem de atletas NO GI
              </TournamentLink>  */}

              <TournamentLink
                // target="_blank"
                href={rotaChavesGi}
              >
                Chaves GI
              </TournamentLink>
              <TournamentLink
                // target="_blank"
                href={rotaChavesNogi}
              >
                Chaves NOGI
              </TournamentLink>


              {/*               <TournamentLink
                href="http://www.campeonatofacil.com/eventos/jj/main/mainall.asp?s=3.5B5B1C9A&u=teste"
                target="_blank"
              >
                Chaves NO GI
              </TournamentLink> */}

              <TournamentLink target="blank" href={tabelaPeso}>
                Tabela de pesos
              </TournamentLink>
              {/* <TournamentLink href="#">Resultados (EM BREVE)</TournamentLink> */}
            </Content>
          </TournamentActions>
        </TournamentDescription>
      </Container>
      <Footer />
    </>
  );
};

export default CircuitoInterDeJiuJitsu2026;
